import api from "../../Api/feathers-client";
import { getAssignmentInfo } from "../Assign/Services";
import { getTaskInfo } from "../Task/Services";
import { getDaysDiff, getFormatedDateTime } from "../../Js/TimeAndDate";
import { userLogs } from "../../Js/Common";
import { findIndex, find } from "lodash";

const extraAssessmentLevelPercetage = [
  {
    level: "BL",
    from: 0,
    to: 19,
    sec: "2160",
  },
  {
    level: "A1",
    from: 20,
    to: 39,
    sec: "79200",
  },
  {
    level: "A2",
    from: 40,
    to: 69,
    sec: "162000",
  },
  {
    level: "B1",
    from: 70,
    to: 84,
    sec: "367200",
  },
  {
    level: "B2",
    from: 85,
    to: 100,
    sec: "558000",
  },
];

// Call backend service to update evaluation result in user-logs
export const updateLog = async (outcome, context, uid, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").patch(
        null,
        {
          outcome,
          context,
        },
        {
          query: {
            site_uuid,
            uid,
          },
        }
      );

      console.log("response", response);
      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        message: "Log updated successfully.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};

// Call backend service to update evaluation result in user-logs
export const upsertSelfLearnProgress = async (
  actor,
  target,
  site_uuid,
  logtype
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let summarylog = await getSummaryLog(actor, target, site_uuid);

      if (summarylog && summarylog.data && summarylog.data.data.length > 1) {
        if (logtype == "extraLog") {
          let assessmentLevel = null;
          let progressLog = await getProgressLog(actor, site_uuid);
          let getPercentage = Math.round(
            +(
              +summarylog.data.data[0]["outcome"]["score"] /
              +summarylog.data.data[0]["outcome"]["totalAssets"]
            ) * 100
          );

          let foundObj = find(extraAssessmentLevelPercetage, (o) => {
            return +getPercentage >= o.from && +getPercentage <= o.to;
          });
          assessmentLevel = foundObj ? foundObj.level : null;
          if (
            progressLog &&
            progressLog.data &&
            progressLog.data.data.length > 0
          ) {
            let outcomeObj = {
              ...progressLog.data.data[0]["outcome"],
              // currentLevel: findFinalLevelForCurrent(
              //   progressLog.data.data[0]["outcome"],
              //   assessmentLevel
              // ),
              assessmentLevel: findFinalLevel(
                progressLog.data.data[0]["outcome"],
                assessmentLevel
              ),
              assessmentSec: getSecOfLevel(
                findFinalLevel(
                  progressLog.data.data[0]["outcome"],
                  assessmentLevel
                )
              ),
            };
            resolve(
              new Promise(async (resolve, reject) => {
                try {
                  let response = await api
                    .service("user-logs")
                    .patch(progressLog.data.data[0]["id"], {
                      outcome: outcomeObj,
                    });
                  console.log("response", response);
                  if (response) {
                    resolve(response);
                  } else {
                    resolve("some issue");
                  }
                } catch (err) {
                  resolve(err);
                }
              })
            );
          }
        } else {
          resolve("Already Inserted");
        }
      } else {
        let progressLog = await getProgressLog(actor, site_uuid);
        let objData = await createObjToInsertOrUpdate(
          actor,
          target,
          site_uuid,
          summarylog.data.data[0]
        );
        if (
          progressLog &&
          progressLog.data &&
          progressLog.data.data.length > 0
        ) {
          let response = await updateProgressLog(
            progressLog.data.data[0]["id"],
            {
              ...progressLog.data.data[0]["outcome"],
              // currentLevel:
              //   logtype == "extraLog"
              //     ? findFinalLevelForCurrent(
              //         progressLog.data.data[0]["outcome"],
              //         objData.assessmentLevel
              //       )
              //     : progressLog.data.data[0]["outcome"]["currentLevel"],
              assessmentLevel:
                logtype == "extraLog"
                  ? findFinalLevel(
                      progressLog.data.data[0]["outcome"],
                      objData.assessmentLevel
                    )
                  : progressLog.data.data[0]["outcome"]["assessmentLevel"],
              assessmentSec:
                logtype == "extraLog"
                  ? getSecOfLevel(
                      findFinalLevel(
                        progressLog.data.data[0]["outcome"],
                        objData.assessmentLevel
                      )
                    )
                  : progressLog.data.data[0]["outcome"]["assessmentSec"],
            },
            progressLog.data.data[0]["context"],
            actor,
            objData,
            site_uuid
          );
          resolve(response);
        } else {
          let response = await insertProgressLog(
            actor,
            objData,
            site_uuid,
            logtype
          );
          resolve(response);
        }
      }
    } catch (err) {
      resolve(err);
    }
  });
};

const getSecOfLevel = (level) => {
  let sec = 0;
  if (level) {
    let index = findIndex(extraAssessmentLevelPercetage, { level: level });
    sec = extraAssessmentLevelPercetage[index]["sec"];
  }
  return sec;
};

export const getProgressLog = (actor, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          actor,
          verb: "selfLearnProgress",
          site_uuid,
        },
      });

      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        data: response,
        message: "Log Found.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};

export const getSummaryLog = (actor, target, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("assignment-summary-logs").find({
        query: {
          actor,
          target,
          site_uuid,
          $sort: {
            createdAt: -1,
          },
        },
      });

      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        data: response,
        message: "Log Found.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};

const findFinalLevel = (progressLog, gainassessmentLevel) => {
  let finalLevel;
  if (progressLog) {
    let gainIndex = findIndex(extraAssessmentLevelPercetage, {
      level: gainassessmentLevel,
    });
    let oldIndex = findIndex(extraAssessmentLevelPercetage, {
      level: progressLog["assessmentLevel"],
    });
    if (gainIndex > oldIndex) {
      finalLevel = extraAssessmentLevelPercetage[gainIndex]["level"];
    } else {
      finalLevel = extraAssessmentLevelPercetage[oldIndex]["level"];
    }
  } else {
    finalLevel = gainassessmentLevel;
  }
  return finalLevel;
};

const findFinalLevelForCurrent = (progressLog, gainassessmentLevel) => {
  let finalLevel;
  if (progressLog) {
    let gainIndex = findIndex(extraAssessmentLevelPercetage, {
      level: gainassessmentLevel,
    });
    let oldIndex = findIndex(extraAssessmentLevelPercetage, {
      level: progressLog["currentLevel"],
    });
    if (gainIndex > oldIndex) {
      finalLevel = extraAssessmentLevelPercetage[gainIndex]["level"];
    } else {
      finalLevel = extraAssessmentLevelPercetage[oldIndex]["level"];
    }
  } else {
    finalLevel = gainassessmentLevel;
  }
  return finalLevel;
};

const insertProgressLog = async (actor, objData, site_uuid, logtype) => {
  let tempObj = { ...objData };
  delete tempObj.firstLoginDate;

  let logObj = {
    actor,
    verb: "selfLearnProgress",
    outcome: {
      details: [tempObj],
      assessments: tempObj.likeAssessment ? [tempObj] : [],
      firstLoginDate: objData.firstLoginDate,
      totalTime: objData.time,
      currentLevel:
        logtype == "extraLog" ? objData.assessmentLevel : objData.level,
      assessmentLevel: logtype == "extraLog" ? objData.assessmentLevel : null,
      assessmentSec:
        logtype == "extraLog" ? getSecOfLevel(objData.assessmentLevel) : 0,
    },
    context: {
      lastContext: objData,
      levelData: [
        {
          level: objData.level,
          levelStartDate: objData.date,
          levelStartDays: objData.daysToAttempt,
          levelLastAttmptDate: objData.date,
          levelLastAttmptDays: objData.daysToAttempt,
        },
      ],
    },
    site_uuid: site_uuid,
    target: null,
    session_uid: null,
  };
  console.log("logObj", logObj);
  return new Promise(async (resolve, reject) => {
    try {
      let response = await userLogs(logObj);
      console.log("response", response);
      if (response) {
        resolve(response);
      } else {
        resolve("some issue");
      }
    } catch (err) {
      resolve(err);
    }
  });
};

const updateProgressLog = async (
  id,
  outcome,
  context,
  actor,
  objData,
  site_uuid
) => {
  let tempObj = { ...objData };
  delete tempObj.firstLoginDate;

  let contextDataPos = findIndex(context.levelData, { level: objData.level });
  let contextData = context;
  if (contextDataPos > -1) {
    contextData.levelData[contextDataPos] = {
      ...contextData.levelData[contextDataPos],
      levelLastAttmptDate: objData.date,
      levelLastAttmptDays: objData.daysToAttempt,
    };
  } else {
    contextData.levelData = [
      ...contextData.levelData,
      {
        level: objData.level,
        levelStartDate: objData.date,
        levelStartDays: objData.daysToAttempt,
        levelLastAttmptDate: objData.date,
        levelLastAttmptDays: objData.daysToAttempt,
      },
    ];
  }

  let logObj = {
    outcome: {
      ...outcome,
      details: [...outcome.details, tempObj],
      assessments: tempObj.likeAssessment
        ? [...outcome.assessments, tempObj]
        : [...outcome.assessments],
      totalTime: (Number(outcome.totalTime) + Number(objData.time)).toString(),
      currentLevel: objData.level,
    },
    context: {
      lastContext: objData,
      levelData: contextData.levelData,
    },
  };
  console.log("logObj", logObj);
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").patch(id, logObj);
      console.log("response", response);
      if (response) {
        resolve(response);
      } else {
        resolve("some issue");
      }
    } catch (err) {
      resolve(err);
    }
  });
};

const createObjToInsertOrUpdate = async (actor, target, site_uuid, summary) => {
  let assignmentData = await getAssignmentInfo(target, site_uuid);
  let taskData = await getTaskInfo(
    assignmentData.data[0]["tasks"]["tasks"][0],
    site_uuid
  );

  let assessmentLevel = null;

  if (taskData.data[0]["tags"]["tags"].indexOf("Special Assessment") > -1) {
    let getPercentage = Math.round(
      +(+summary["outcome"]["score"] / +summary["outcome"]["totalAssets"]) * 100
    );

    let foundObj = find(extraAssessmentLevelPercetage, (o) => {
      return +getPercentage >= o.from && +getPercentage <= o.to;
    });
    assessmentLevel = foundObj ? foundObj.level : null;
  }

  let firstLogin = await getFirstLogin(actor, site_uuid);
  let currentDate = new Date();
  let idealDays = taskData.data[0]["tags"]["tags"].filter((val) => {
    return !isNaN(val);
  });
  let level = taskData.data[0]["tags"]["tags"].filter((val) => {
    return (
      val == "A1" ||
      val == "A2" ||
      val == "B1" ||
      val == "B2" ||
      val == "C1" ||
      val == "C2"
    );
  });
  return {
    assignmentId: assignmentData.data[0].uid,
    assignmentTitle: assignmentData.data[0].title,
    time: assignmentData.data[0].estimated_time,
    idealDays: idealDays && idealDays.length > 0 ? idealDays[0] : 0,
    daysToAttempt: getDaysDiff(
      firstLogin.data.data[0]["createdAt"],
      currentDate.toDateString()
    ).toString(),
    firstLoginDate: firstLogin.data.data[0]["createdAt"],
    summaryLogId: summary["uid"],
    score: summary["outcome"]["score"],
    attemptedAssets: summary["outcome"]["attemptedAssets"],
    totalAssets: summary["outcome"]["totalAssets"],
    level: level && level.length > 0 ? level[0] : "",
    likeAssessment:
      assignmentData.data[0]["is_exam"] ||
      (+assignmentData.data[0]["defaults"]["defaults"]["noofattempts"] == 1 &&
        !assignmentData.data[0]["defaults"]["defaults"][
          "showanswerfunctionality"
        ]),
    date: getFormatedDateTime(currentDate),
    tags: taskData.data[0]["tags"]["tags"],
    assessmentLevel: assessmentLevel,
  };
};

let getFirstLogin = async (actor, site_uuid) => {
  return new Promise(async (resolve, reject) => {
    try {
      let response = await api.service("user-logs").find({
        query: {
          actor: actor,
          site_uuid: site_uuid,
          verb: "login",
          $sort: {
            created_at: 1,
          },
          $limit: 1,
        },
      });

      if (response.length == 0) {
        resolve({
          status: 404,
          message: "Not found",
        });
      }
      resolve({
        status: 200,
        data: response,
        message: "Log Found.",
      });
    } catch (error) {
      resolve({
        status: 500,
        message: error.message,
      });
    }
  });
};
